import SlidePort from "../components/SlidePort";
import { Link } from "react-router-dom";

const WebsiteDev = () => {
  return (
    <div className="pt-[70px] pb-[130px]">
      <div className="flex parent">
        <Link to="/frontend-developer" className="group">
          <h2 className="text-[32px] font-bold group-hover:text-custom-primary-100 group-hover:right-[10px] group-hover:ml-[10px] duration-200">
            WEB DESIGN
          </h2>
          <h3 className="text-[18px] text-custom-gray-75 group-hover:ml-[-10px] duration-200">
            Front-end Developer
          </h3>
        </Link>
      </div>

      <SlidePort />
    </div>
  );
};

export default WebsiteDev;
